import { inject, observer, Provider } from 'mobx-react';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { Dropdown, Grid, Icon } from 'semantic-ui-react';
import withNavigation from '../../hocs/withNavigation';
import { AgGridReact } from '@ag-grid-community/react/lib/agGridReact';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css';
import { AgGridText } from '../../core/agGridText';
import OpenItem from "../../components/OpenItem";
import { GridReadyEvent } from '@ag-grid-enterprise/all-modules';
import { RootStore } from '../../stores/RootStore';


interface IStores {
	
}

interface ISelectionPageProps {
	navigate?: NavigateFunction;
	RootStore?: RootStore;
}

class SelectionPage extends React.Component<ISelectionPageProps> {
	private stores: IStores;

	constructor(props: any) {
		super(props);

		//this.stores = { CalibraStore: new CalibraStore(this.props.navigate, this.props.RootStore) };

	}

	handleGridReady(event: GridReadyEvent) {
		event.api.sizeColumnsToFit();
	}

	componentDidMount(): void {		

		if ((this.props.RootStore.currentUser.VodafoneBO || this.props.RootStore.currentUser.VodafoneSupervisor) &&
				!this.props.RootStore.currentUser.HoldingAdmin &&
				!this.props.RootStore.currentUser.HoldingGlobalViewer &&
				!this.props.RootStore.currentUser.StoreAdmin &&
				!this.props.RootStore.currentUser.CreditManager &&
				!this.props.RootStore.currentUser.OnlinePickup &&
				!this.props.RootStore.currentUser.IsStoreCalibrator &&
				!this.props.RootStore.currentUser.IsHQCalibrator
			) {
				this.props.RootStore.selectSelection(1)
				
			}
		// let storeCookie=	this.stores.CalibraStore.readCookie('SelectedStore')

		// if(storeCookie){
		// 	this.stores.CalibraStore.selectedStoreCodeTask = storeCookie;
		// 	this.stores.CalibraStore.selectedStoreCodeOffer = storeCookie;
		// }else{
		// 	this.stores.CalibraStore.selectedStoreCodeTask = 'all';
		// 	this.stores.CalibraStore.selectedStoreCodeOffer = 'all';
		// }
	
		//this.stores.CalibraStore.getAllCalibras();
	}


	public render() {
		return (
			<div>
				<Provider {...this.stores}>
					<div>
                        <Grid style={{ paddingTop: 50 }}>
                            <Grid.Row columns={3} centered>
                                <Grid.Column textAlign="center" width={4}>
                                    <div style={{ fontWeight: 'bold' }}>MMSConnect</div>
                                    <Icon
                                        name="file alternate outline"
                                        style={{ cursor: 'pointer' }}
                                        size="massive"
                                        color="red"
                                        bordered
                                        onClick={() => this.props.RootStore.selectSelection(1)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={1} />
                                <Grid.Column textAlign="center" width={4}>
                                    <div style={{ fontWeight: 'bold' }}>Calibra</div>
                                    <Icon
                                        name="television"
                                        style={{ cursor: 'pointer' }}
                                        size="massive"
                                        bordered
                                        onClick={() => this.props.RootStore.selectSelection(2)}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
					</div>
				</Provider>
			</div>
		);
	}
}

export default withNavigation(inject('RootStore')(observer(SelectionPage)));